/* PTQuickBuy loader (always loaded, deferred, cached) — see snippets/pt-quick-buy-loader.liquid for the overview.
   Labels purchase-mode buttons, intercepts their clicks, adds single-variant products in one request (with Rebuy
   attribution for Rebuy cards), opens the Smart Cart at once with an "Adding…" state, and loads the buy sheet once a
   Choose button is on screen or pressed. */
(function () {
  if (window.PTQuickBuy) return;
  var cfg = window.PTQuickBuyConfig;
  if (!cfg) return;
  if (cfg.root.slice(-1) !== '/') cfg.root += '/';
  var html = document.documentElement;
  var moduleP = null;
  var assetPromises = {};
  var pendingOpening = null;

  function loadAsset(kind, url) {
    if (assetPromises[kind]) return assetPromises[kind];
    assetPromises[kind] = new Promise(function (resolve, reject) {
      var node = document.createElement(kind === 'css' ? 'link' : 'script');
      if (kind === 'css') { node.rel = 'stylesheet'; node.href = url; }
      else { node.src = url; node.async = true; }
      function failed() {
        delete assetPromises[kind];
        node.remove();
        reject(new Error('Quick buy ' + kind + ' could not load'));
      }
      node.onerror = failed;
      node.onload = function () {
        if (kind === 'js' && !(window.PTQuickBuy && window.PTQuickBuy.openSheet)) { failed(); return; }
        resolve();
      };
      document.head.appendChild(node);
    });
    return assetPromises[kind];
  }

  function load() {
    if (moduleP) return moduleP;
    moduleP = Promise.all([loadAsset('css', cfg.css), loadAsset('js', cfg.js)])
      .then(function () { return window.PTQuickBuy; })
      .catch(function (error) { moduleP = null; throw error; });
    return moduleP;
  }

  /* Legacy/seasonal product cache. Scoped recommendations request fresh data per open. */
  var productP = {};
  function productJSON(handle) {
    if (!productP[handle]) {
      productP[handle] = fetch(cfg.root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete productP[handle]; throw e; });
    }
    return productP[handle];
  }

  // Warm assets once. Only legacy/seasonal callers also warm their shared product cache.
  function warmUp(b) {
    load().catch(function () {});
    var widgetId = b.getAttribute('data-pt-qb-widget');
    if (widgetId === '317188' || widgetId === '311321') return;
    var h = b.getAttribute('data-pt-qb-handle');
    if (h) productJSON(h).catch(function () {});
  }

  /* Globo: a product mapped to an enabled option set has fields only its product page can collect.
     null = Globo data not available yet (unknown → treat as product page). */
  function personalized(pid) {
    var G = window.GPOConfigs;
    var map = G && G.productOptionSetMap;
    if (!map) return null;
    if (!pid || !map[pid]) return false;
    return String(map[pid]).split(',').some(function (sid) {
      var o = G.options && G.options[sid.trim()];
      return !(o && String(o.status) === '1');
    });
  }

  /* The purchase mode comes from what the product page actually asks for: all custom fields on this store come from
   Globo option sets, so a product without one is bought here with exactly the same information as on its page — no
   naming rules or tagging needed. One manual override: tag pt-rec:custom sends a product to its page anyway. */
  function tagSaysPDP(tags) {
    return /(^|,)\s*pt-rec:custom\s*(,|$)/i.test(String(tags || ''));
  }

  function purchaseMode(pid, tags, variants) {
    if (tagSaysPDP(tags) || personalized(pid) !== false) return 'custom';
    return Number(variants) === 1 ? 'quick' : 'choose';
  }

  function modeOf(el) {
    return purchaseMode(el.getAttribute('data-pt-qb-pid'), el.getAttribute('data-pt-qb-tags'),
      parseInt(el.getAttribute('data-pt-qb-variants'), 10) || 0);
  }

  function track(name, el, extra) {
    var d = {
      widget_id: el ? el.getAttribute('data-pt-qb-widget') || '' : '',
      product_id: el ? el.getAttribute('data-pt-qb-pid') || '' : '',
      origin: el ? (el.getAttribute('data-pt-qb-widget') ? 'rebuy' : 'theme') : 'theme',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || ''
    };
    if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('pt:quickbuy', { detail: { event: name, data: d } })); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pt_quickbuy_' + name, d); } catch (e) {}
  }

  /* Button labels + one-time view events. Rebuy re-renders its widgets, so this runs whenever cards are added. */
  var seen = {};
  var viewObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var b = en.target;
      viewObs.unobserve(b);
      if (b.matches('#rebuy-widget-317188 .rebuy-product-block')) { load().catch(function () {}); return; }
      // Choose buttons anywhere, and every Smart Cart card (its image/title opens the sheet too).
      if (b.getAttribute('data-pt-qb-mode') === 'choose' || b.closest('.widget-layout-line')) warmUp(b);
      var key = (b.getAttribute('data-pt-qb-widget') || 'theme') + ':' + b.getAttribute('data-pt-qb-pid');
      if (seen[key]) return;
      seen[key] = true;
      track('view', b, { mode: b.getAttribute('data-pt-qb-mode') || '' });
    });
  }, { threshold: 0.5 }) : null;

  /* Rebuy cards: Personalize opens the product page itself, so it links to the product as such (no preselected
     variant, Rebuy's _rdiscovery parameters kept), like the card image and title. Quick Add / Choose keep Rebuy's
     link, which only their fallbacks use; a button relabelled away from Personalize gets it back. */
  function plainLink(b, m) {
    if (!b.hasAttribute('data-pt-qb-widget')) return;
    var href = b.getAttribute('href') || '';
    if (m === 'custom') {
      var plain = href.replace(/([?&])variant=\d+&/, '$1').replace(/[?&]variant=\d+$/, '');
      if (plain !== href) { b.ptQbHref = href; b.setAttribute('href', plain); }
    } else if (b.ptQbHref) {
      b.setAttribute('href', b.ptQbHref);
      b.ptQbHref = null;
    }
  }

  function label() {
    if (viewObs) Array.prototype.slice.call(document.querySelectorAll('#rebuy-widget-317188 .rebuy-product-block'), 0, 2).forEach(function (card) {
      if (!card.ptQbAssetObserved) { card.ptQbAssetObserved = true; viewObs.observe(card); }
    });
    document.querySelectorAll('[data-pt-qb]').forEach(function (b) {
      var m = modeOf(b);
      if (b.getAttribute('data-pt-qb-mode') !== m) b.setAttribute('data-pt-qb-mode', m);
      plainLink(b, m);
      var cartAdd = !!b.closest('#rebuy-cart') && (b.classList.contains('pt-gs__btn') || b.getAttribute('data-pt-qb-widget') === '311321');
      var quick = b.querySelector('.pt-qb-l--quick');
      if (cartAdd && quick && quick.textContent !== 'Add') quick.textContent = 'Add';
      var ch = b.querySelector('.pt-qb-l--choose');
      if (ch) {
        var t = cartAdd ? 'Add' : (/size/i.test(b.getAttribute('data-pt-qb-options') || '') ? 'Choose Size' : 'Choose Style');
        if (ch.textContent !== t) ch.textContent = t;
      }
      if (viewObs && !b.ptQbObserved) { b.ptQbObserved = true; viewObs.observe(b); }
    });
  }
  function hasButton(n) {
    return n.nodeType === 1 && (n.hasAttribute('data-pt-qb') || !!n.querySelector('[data-pt-qb]') ||
      n.matches('#rebuy-widget-317188 .rebuy-product-block') || !!n.querySelector('#rebuy-widget-317188 .rebuy-product-block'));
  }
  function startObserver() {
    label();
    // Label (re)rendered cards in the same task, before they paint; a deferred pass showed "View" for a frame.
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) if (hasButton(added[j])) { label(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    // Globo's option map can arrive after the cards: relabel once it is there.
    var tries = 0;
    (function waitGlobo() {
      if (window.GPOConfigs && window.GPOConfigs.productOptionSetMap) { label(); return; }
      if (++tries < 40) setTimeout(waitGlobo, 250);
    })();
  }

  // Rec images keep a quiet placeholder until they have loaded (CSS in the loader snippet).
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest && t.closest('.rebuy-widget')) t.setAttribute('data-pt-img', '');
  }, true);

  /* "Adding…" state in the Smart Cart until Rebuy has refreshed it (or 3 s). */
  var pendingTimer = 0;
  function pending(on) {
    clearTimeout(pendingTimer);
    html.classList.toggle('pt-cart-pending', !!on);
    if (on) pendingTimer = setTimeout(function () { html.classList.remove('pt-cart-pending'); }, 3000);
  }
  document.addEventListener('rebuy:cart.change', function () { pending(false); });

  /* Rebuy may auto-open only after asynchronous enrichment. Keep its documented skip_open guard through that
     work, until a different successful add or an explicit cart opening. Keep the guard even after an error:
     the request may have committed, and only the next cart intent should reopen it. Never hide/reopen the drawer. */
  var quietAdd = null;
  function releaseQuietAdd() {
    var state = quietAdd;
    quietAdd = null;
    if (state && state.cart.skip_open === true) state.cart.skip_open = state.previous;
  }
  function beginQuietAdd(o) {
    if (String(o.widgetId) !== '317188' || o.openCart !== false) return;
    var cart = window.Rebuy && window.Rebuy.SmartCart;
    if (!cart) return;
    if (!quietAdd || quietAdd.cart !== cart) {
      quietAdd = { cart: cart, previous: cart.skip_open };
    }
    cart.skip_open = true;
  }
  document.addEventListener('rebuy:smartcart.show', releaseQuietAdd);
  // Header refreshes can leave a new cart link without Rebuy's direct listener.
  // Run only if native handlers did not handle the click; keep unavailable-cart navigation intact.
  document.addEventListener('click', function headerCartFallback(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target;
    var link = target && target.closest && target.closest('#cart-icon-bubble');
    if (!link || link.hasAttribute('disable-rebuy') || link.classList.contains('disable-rebuy') ||
        link.target === '_blank') return;
    var cart = window.Rebuy && window.Rebuy.SmartCart;
    if (!cart || cart.status !== 'ready' || typeof cart.show !== 'function' ||
        !document.body.classList.contains('smart-cart--enabled')) return;
    releaseQuietAdd();
    cart.show(event);
  });

  document.addEventListener('rebuy:cart.add', function (event) {
    if (!quietAdd) return;
    var item = event.detail && event.detail.item;
    var items = item && Array.isArray(item.items) ? item.items : [item];
    items.forEach(function (line) {
      if (!quietAdd || !line || !(line.id || line.variant_id)) return;
      var props = line.properties || {};
      if (props._source !== 'Rebuy' || String(props._widget_id) !== '317188') releaseQuietAdd();
    });
  }, true);

  /* After any successful add. Rebuy picks up the add request and refreshes the cart by itself; if it has not
     done so within 2.5 s, ask it once. openCart:false keeps the drawer closed (e.g. pages with their own UI). */
  function afterAdd(o) {
    o = o || {};
    if (o.openCart !== false) releaseQuietAdd();
    var R = window.Rebuy;
    var smart = R && R.SmartCart && document.body.classList.contains('smart-cart--enabled');
    var refreshed = false;
    function onChange() { refreshed = true; }
    document.addEventListener('rebuy:cart.change', onChange, { once: true });
    setTimeout(function () {
      document.removeEventListener('rebuy:cart.change', onChange);
      if (!refreshed && R && R.Cart && typeof R.Cart.fetchCart === 'function') { try { R.Cart.fetchCart(); } catch (e) {} }
    }, 2500);
    if (o.openCart === false) return;
    if (!smart) { window.location.href = cfg.root + 'cart'; return; }
    if (!document.body.classList.contains('rebuy-cart-visible')) {
      pending(true);
      try { R.SmartCart.show(); } catch (e) { window.location.href = cfg.root + 'cart'; }
    }
  }

  function updateIcon(sections) {
    var s = sections && sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (!s || !bubble) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = s;
    var inner = tmp.querySelector('.shopify-section');
    bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
  }

  // UI integrations must never turn a committed cart add into a failed purchase.
  function lifecycle(o, name, value, extra) {
    if (typeof o[name] === 'function') {
      try { o[name](value, extra); } catch (error) { console.warn('PTQuickBuy feedback callback failed:', name); }
    }
  }

  function quantityOf(o) {
    var quantity = Number(o.quantity == null || o.quantity === '' ? 1 : o.quantity);
    var rules = o.quantityRules || {};
    var minimum = Number(rules.min) || 1;
    var maximum = Number(rules.max) || Infinity;
    var increment = Number(rules.increment) || 1;
    if (!Number.isInteger(quantity) || quantity < minimum || quantity > maximum ||
        (quantity - minimum) % increment !== 0) throw new Error('Please choose a valid quantity.');
    return quantity;
  }

  var feedbackTiming = { picker: 700, source: 2000 };

  function widgetFor(id) {
    var widgets = window.Rebuy && window.Rebuy.widgets || [];
    return widgets.filter(function (widget) { return String(widget.id) === String(id); })[0];
  }
  function productFor(o) {
    var widget = widgetFor(o.widgetId);
    return widget && widget.data && (widget.data.products || []).filter(function (p) {
      return String(p.id) === String(o.productId);
    })[0];
  }
  // These controls edit Rebuy's product model; native settings continue to own the rules.
  // The capture handler never handles quantities outside the two scoped widgets.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-pt-quantity-step]');
    if (!button) return;
    var id = button.getAttribute('data-pt-quantity-widget');
    if (id !== '317188' && id !== '311321') return;
    event.preventDefault();
    event.stopPropagation();
    var widget = widgetFor(id);
    var settings = widget && widget.data && (widget.data.config || widget.data.settings) || {};
    var inputs = settings.quantity_inputs || {};
    var product = productFor({ widgetId: id, productId: button.getAttribute('data-pt-quantity-product') });
    var card = button.closest('.rebuy-product-block');
    var action = card && card.querySelector('[data-pt-qb]');
    if (button.disabled || !inputs.enabled || !product || product.status === 'adding' || product.status === 'added' ||
        action && (action.ptQbRequestPending || action.hasAttribute('data-pt-qb-state'))) return;
    var rules = { min: inputs.min_value, max: inputs.max_value,
      increment: settings.quantity_rules && settings.quantity_rules.increment };
    var current = product.quantity == null ? inputs.default_quantity || rules.min || 1 : product.quantity;
    try {
      var next = Number(current) + Number(button.getAttribute('data-pt-quantity-step')) * (Number(rules.increment) || 1);
      product.quantity = quantityOf({ quantity: next, quantityRules: rules });
    } catch (error) { /* A bound cannot silently clamp or change the selected variant. */ }
  }, true);
  function widgetRoot(id) {
    return document.querySelector('#rebuy-widget-' + id + '.rebuy-widget');
  }
  function focusWidget(o) {
    var root = widgetRoot(o.widgetId);
    var target = root && (root.querySelector('.primary-title') || root);
    if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  }
  // The latest confirmed add is a receipt, not a second cart or a running total.
  var pdpAddReceipt = null;
  function clearPdpAddReceipt() {
    pdpAddReceipt = null;
    var region = document.querySelector('[data-pt-addon-receipt]');
    if (region) region.remove();
  }
  document.addEventListener('rebuy:smartcart.show', clearPdpAddReceipt);
  function renderPdpAddReceipt(o, item, variantTitle) {
    if (item) pdpAddReceipt = {
      title: o.kiwi && o.kiwi.title || 'Item',
      variant: variantTitle && variantTitle !== 'Default Title' ? variantTitle : '',
      quantity: item.quantity
    };
    if (!pdpAddReceipt) return;
    var root = widgetRoot('317188');
    var heading = root && root.querySelector('.primary-title');
    if (!heading || !heading.parentNode) return;
    var region = root.querySelector('[data-pt-addon-receipt]');
    if (!region) {
      region = document.createElement('div');
      region.className = 'pt-addon-receipt';
      region.setAttribute('data-pt-addon-receipt', '');
      region.innerHTML = '<div class="pt-addon-receipt__message" role="status" aria-live="polite" aria-atomic="true"><strong>✓ Added to cart</strong><span class="pt-addon-receipt__detail"></span></div><a class="pt-addon-receipt__link">View cart →</a>';
      var link = region.querySelector('a');
      link.href = cfg.root + 'cart';
      link.addEventListener('click', function (event) {
        var cart = window.Rebuy && window.Rebuy.SmartCart;
        if (cart && typeof cart.show === 'function') {
          releaseQuietAdd();
          try { cart.show(); event.preventDefault(); clearPdpAddReceipt(); }
          catch (error) { /* Keep the real cart link as the fallback. */ }
        }
      });
      heading.parentNode.insertBefore(region, heading.nextSibling);
    }
    var value = pdpAddReceipt.title + (pdpAddReceipt.variant ? ' · ' + pdpAddReceipt.variant : '') + ' · Qty ' + pdpAddReceipt.quantity;
    var detail = region.querySelector('.pt-addon-receipt__detail');
    if (detail.textContent !== value) detail.textContent = value;
  }
  function announce(o, item, variantTitle) {
    if (String(o.widgetId) === '317188') {
      renderPdpAddReceipt(o, item, variantTitle);
      return;
    }
    var root = widgetRoot(o.widgetId);
    // The native host exists before the first product response and View render.
    if (!root && String(o.widgetId) === '317188') root = document.querySelector('[data-rebuy-id="317188"]');
    if (!root || !root.parentNode) return;
    var selector = '[data-pt-qb-feedback="' + o.widgetId + '"]';
    var region = document.querySelector(selector);
    if (!region) {
      region = document.createElement('p');
      region.className = 'pt-qb-feedback';
      region.setAttribute('data-pt-qb-feedback', o.widgetId);
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      root.parentNode.insertBefore(region, root.nextSibling);
    }
    region.removeAttribute('hidden');
    if (item) region.textContent = 'Added ' + item.quantity + ' × ' + (o.kiwi && o.kiwi.title || 'item') +
      (variantTitle && variantTitle !== 'Default Title' ? ', ' + variantTitle : '') + ' to your cart.';
  }
  function sourceError(o, error) {
    if (error && o.sheetActive) return;
    var root = widgetRoot(o.widgetId);
    var card = root && root.querySelector('.product-id-' + o.productId);
    if (!card && o.trigger && o.trigger.closest) card = o.trigger.closest('.rebuy-product-block');
    if (!card) return;
    var region = card.querySelector('.pt-qb-error');
    if (!error) { if (region) region.remove(); return; }
    if (!region) { region = document.createElement('p'); region.className = 'pt-qb-error'; region.setAttribute('role', 'alert'); card.appendChild(region); }
    region.textContent = error.message || 'Could not add to cart. Please try again.';
  }
  function bindQuantity(o) {
    if (String(o.widgetId) !== '317188' && String(o.widgetId) !== '311321') return o;
    o.feedbackScoped = true;
    var widget = widgetFor(o.widgetId);
    var settings = widget && widget.data && (widget.data.config || widget.data.settings) || {};
    var inputs = settings.quantity_inputs || {};
    var product = productFor(o);
    o.quantityEnabled = inputs.enabled === true;
    o.quantityRules = { min: inputs.min_value, max: inputs.max_value,
      increment: settings.quantity_rules && settings.quantity_rules.increment };
    if (product) { o.quantity = product.quantity; o.variantId = product.selected_variant && product.selected_variant.id || o.variantId; }
    o.onQuantityChange = function (value) {
      o.quantity = quantityOf({ quantity: value, quantityRules: o.quantityRules });
      var current = productFor(o);
      if (current) current.quantity = o.quantity;
    };
    o.onVariantChange = function (id) {
      o.variantId = id;
      var current = productFor(o);
      var variant = current && current.variants.filter(function (v) { return String(v.id) === String(id); })[0];
      if (variant) {
        current.selected_variant = variant;
        current.selected_variant_id = variant.id;
        ['option1', 'option2', 'option3'].forEach(function (key) { current[key] = variant[key]; });
      }
    };
    o.onAddError = function (error) {
      if (String(o.widgetId) === '311321') flash(o.trigger, null, productFor(o));
      sourceError(o, error);
    };
    o.onAdding = function () {
      if (String(o.widgetId) === '311321') flash(o.trigger, 'adding', productFor(o));
      sourceError(o, null);
    };
    o.onAdded = function (response, detail) { announce(o, detail.item, detail.variantTitle); };
    announce(o);
    return o;
  }

  /* One request: add the line (with attribution when it comes from a Rebuy card) and get the header cart icon back. */
  function add(o) {
    var props = {};
    if (o.properties) for (var k in o.properties) props[k] = o.properties[k];
    if (o.widgetId && o.attribution) {
      props._source = 'Rebuy';
      props._attribution = o.attribution;
      props._widget_id = String(o.widgetId);
    }
    var quantity;
    try { quantity = quantityOf(o); } catch (error) {
      lifecycle(o, 'onAddError', error);
      return Promise.reject(error);
    }
    var item = { id: parseInt(o.variantId, 10), quantity: quantity };
    if (Object.keys(props).length) item.properties = props;
    if (o.trigger) o.trigger.ptQbRequestPending = true;
    lifecycle(o, 'onAdding', item);
    beginQuietAdd(o);
    return fetch(cfg.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var rejected = new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart');
          rejected.ptConfirmedFailure = true;
          throw rejected;
        }
        if (!res.j || typeof res.j !== 'object') throw new Error('Unrecognized cart response');
        try {
        updateIcon(res.j.sections);
        if (o.trigger && o.trigger.hasAttribute && o.trigger.hasAttribute('data-pt-qb')) flash(o.trigger, 'added');
        track('add_success', o.trigger || null, { variant_id: String(item.id), mode: o.mode || '' });
        afterAdd(o);
        } catch (uiError) { console.warn('PTQuickBuy cart UI refresh failed after a successful add'); }
        lifecycle(o, 'onAdded', res.j, { item: item, variantTitle: o.variantTitle });
        return res.j;
      }).catch(function (error) {
        if (!error.ptConfirmedFailure && (String(o.widgetId) === '317188' || String(o.widgetId) === '311321')) {
          error = new Error("We couldn't confirm the cart update. Check your cart before trying again.");
        }
        lifecycle(o, 'onAddError', error);
        throw error;
      }).finally(function () { if (o.trigger) o.trigger.ptQbRequestPending = false; });
  }

  function fromButton(b) {
    return bindQuantity({
      handle: b.getAttribute('data-pt-qb-handle'),
      productId: b.getAttribute('data-pt-qb-pid'),
      variantId: b.getAttribute('data-pt-qb-variant'),
      quantity: b.getAttribute('data-pt-qb-quantity'),
      quantityRules: { min: b.getAttribute('data-pt-qb-quantity-min'),
        max: b.getAttribute('data-pt-qb-quantity-max'), increment: b.getAttribute('data-pt-qb-quantity-increment') },
      widgetId: b.getAttribute('data-pt-qb-widget') || '',
      attribution: b.getAttribute('data-pt-qb-attribution') || '',
      url: b.getAttribute('href'),
      kiwi: {
        title: b.getAttribute('data-pt-qb-title') || '',
        tags: b.getAttribute('data-pt-qb-tags') || '',
        vendor: b.getAttribute('data-pt-qb-vendor') || '',
        collections: b.getAttribute('data-pt-qb-collections') || ''
      },
      trigger: b
    });
  }

  /* One feedback helper for custom cards, native cards and the picker CTA. Five seconds
     is a cleanup fallback; the picker/source confirmation timings are centralized above. */
  function flash(b, state, product, onClear) {
    // The custom cart card uses the same native status model as its quantity buttons.
    if (!product && b && b.getAttribute('data-pt-qb-widget') === '311321') {
      product = productFor({ widgetId: '311321', productId: b.getAttribute('data-pt-qb-pid') });
    }
    var owner = b || product;
    if (!owner) return;
    clearTimeout(owner.ptQbFlashTimer);
    if (b) { if (state) b.setAttribute('data-pt-qb-state', state); else b.removeAttribute('data-pt-qb-state'); }
    if (product) product.status = state === 'adding' || state === 'added' ? state : 'ready';
    if (!state) return;
    owner.ptQbFlashTimer = setTimeout(function () {
      if (state === 'adding' && owner.ptQbRequestPending) return;
      if (b && b.getAttribute('data-pt-qb-state') === state) b.removeAttribute('data-pt-qb-state');
      if (product && product.status === state) product.status = 'ready';
      if (onClear) onClear();
    }, state === 'added' ? 5000 : 10000);
  }

  function open(handle, o) {
    o = o || {};
    var scoped = String(o.widgetId) === '317188' || String(o.widgetId) === '311321';
    if (!scoped) return load().then(function (Q) { return Q.openSheet(handle, o); });
    if (pendingOpening) pendingOpening.cancel();
    var cancelled = false, handedOff = false, cancelResolve;
    var cancelPromise = new Promise(function (resolve) { cancelResolve = resolve; });
    var owner = { cancel: cancelOpening };
    pendingOpening = owner;
    var from = o.trigger;
    var previousBusy = from && from.getAttribute('aria-busy');
    if (from) { from.ptQbOpeningOwner = owner; from.setAttribute('aria-busy', 'true'); }
    var card = from && from.closest && from.closest('.rebuy-product-block');
    var image = card && card.querySelector('.rebuy-product-media img');
    var title = card && card.querySelector('.rebuy-product-title');
    o.previewTitle = o.previewTitle || o.kiwi && o.kiwi.title || title && title.textContent.trim() || '';
    o.previewImage = o.previewImage || image && (image.currentSrc || image.src) || '';
    announce(o);
    var region = document.querySelector('[data-pt-qb-feedback="' + o.widgetId + '"]');
    if (region) { region.ptQbOpeningOwner = owner; region.textContent = 'Loading product options…'; }
    var controller = 'AbortController' in window ? new AbortController() : null;
    o.cancelProductRequest = function () { if (controller) controller.abort(); };
    o.productRequestHandle = handle;
    o.productRequest = Promise.resolve().then(function () {
      return fetch(cfg.root + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin', cache: 'no-store', signal: controller ? controller.signal : undefined
      });
    }).then(function (response) { if (!response.ok) throw new Error(response.status); return response.json(); });
    // The fresh request can reject before assets finish. The modal still receives
    // the original rejecting promise and owns its visible Retry state.
    o.productRequest.catch(function () {});
    function releaseOpening() {
      window.removeEventListener('keydown', onOpeningKey, true);
      if (pendingOpening === owner) pendingOpening = null;
      if (from && from.ptQbOpeningOwner === owner) {
        delete from.ptQbOpeningOwner;
        if (previousBusy === null) from.removeAttribute('aria-busy'); else from.setAttribute('aria-busy', previousBusy);
      }
      if (region && region.ptQbOpeningOwner === owner) {
        delete region.ptQbOpeningOwner;
        if (region.textContent === 'Loading product options…') region.textContent = '';
      }
    }
    function cancelOpening() {
      if (cancelled || handedOff) return;
      cancelled = true; o.cancelProductRequest(); releaseOpening();
      lifecycle(o, 'onSheetClose');
      cancelResolve();
    }
    function onOpeningKey(event) {
      if (event.key !== 'Escape') return;
      event.preventDefault(); event.stopImmediatePropagation(); cancelOpening();
    }
    window.addEventListener('keydown', onOpeningKey, true);
    var ready = load().then(function (Q) {
      if (cancelled) return;
      handedOff = true; releaseOpening();
      return Q.openSheet(handle, o);
    }).catch(function (error) {
      if (cancelled) return;
      o.cancelProductRequest(); releaseOpening(); throw error;
    });
    return Promise.race([ready, cancelPromise]);
  }

  // Also warm while the finger is still down (covers cards tapped before they were counted as seen).
  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('#rebuy-widget-317188 .rebuy-product-block')) { load().catch(function () {}); return; }
    var b = e.target.closest('[data-pt-qb][data-pt-qb-mode="choose"]');
    if (!b) {
      var block = e.target.closest('.rebuy-widget.widget-layout-line .rebuy-product-block');
      b = block && block.querySelector('[data-pt-qb]');
    }
    if (b) warmUp(b);
  }, { passive: true });
  document.addEventListener('focusin', function (event) {
    if (event.target.closest && event.target.closest('#rebuy-widget-317188 .rebuy-product-block')) load().catch(function () {});
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || !e.target.closest) return;
    var b = e.target.closest('[data-pt-qb]');
    var view = false;
    if (!b) {
      // Smart Cart cards: the image and (two-line) title open a preview sheet with the full name, so the shopper
      // learns more without leaving the cart. Product page cards keep their links.
      var part = e.target.closest('.rebuy-widget.widget-layout-line .rebuy-product-media, .rebuy-widget.widget-layout-line .rebuy-product-info');
      var block = part && part.closest('.rebuy-product-block');
      b = block && block.querySelector('[data-pt-qb]');
      if (!b) return;
      view = true;
    }
    // Busy or just added: ignore repeats (taps are also blocked by CSS; this covers keyboard and scripted clicks).
    if (b.ptQbRequestPending || b.hasAttribute('data-pt-qb-state')) { e.preventDefault(); e.stopPropagation(); return; }
    var m = modeOf(b);
    b.setAttribute('data-pt-qb-mode', m);
    plainLink(b, m);
    track('click', b, { mode: m, via: view ? 'card' : 'button' });
    if (m === 'custom' && !view) return; // the link opens the product page (Rebuy discovery parameters kept)
    e.preventDefault();
    e.stopPropagation();
    var o = fromButton(b);
    o.mode = m;
    o.view = view;
    // The scoped sheet distinguishes a genuine Default Title product from a
    // one-variant product with a real required option (for example one size).
    // A variant count of one alone must not bypass that explicit choice.
    var scopedChoice = String(o.widgetId) === '317188' || String(o.widgetId) === '311321';
    if (m === 'quick' && o.variantId && !view && !scopedChoice) {
      flash(b, 'adding');
      add(o).catch(function (error) { flash(b, null); if (String(o.widgetId) === '311321') sourceError(o, error); else window.location.href = o.url; });
      return;
    }
    flash(b, 'opening');
    open(o.handle, o).then(
      function () { if (b.getAttribute('data-pt-qb-state') === 'opening') flash(b, null); },
      function () { flash(b, null); window.location.href = o.url; }
    );
  }, true);

  window.PTQuickBuy = {
    config: cfg,
    load: load,
    productJSON: productJSON,
    open: open,
    add: add,
    afterAdd: afterAdd,
    personalized: personalized,
    tagSaysPDP: tagSaysPDP,
    track: track,
    pending: pending,
    lifecycle: lifecycle,
    quantityOf: quantityOf,
    flash: flash,
    feedbackTiming: feedbackTiming,
    focusWidget: focusWidget,
    sourceError: sourceError
  };

  function connectNativeRecommendation(widget) {
    if (!widget || String(widget.id) !== '317188') return;
    if (widget.ptQuickBuyConnected) {
      if (widget.View && widget.View.vue) widget.View.vue.addToCart = widget.addToCart;
      announce({ widgetId: '317188' });
      if (widget.ptQuickBuyRefresh) widget.ptQuickBuyRefresh();
      return;
    }
    widget.ptQuickBuyConnected = true;
    var busy = {};
    var operations = {};
    var confirmedAdded = {};
    var refreshTimer = 0;
    var refreshInFlight = false;
    var refreshAgain = false;
    var requestedMembership = null;
    var holdUntil = 0;
    var displayLimit = 2;
    // main-product emits native data-rebuy-limit=12 before widget construction.
    // Every native request uses that pool; only the displayed list is capped at two.
    var initialResponseSeen = !!(widget.data && widget.data.products && widget.data.products.length);
    var initialWatchdog = 0;

    function initialFeedback(state) {
      announce({ widgetId: '317188' });
      var region = document.querySelector('[data-pt-qb-feedback="317188"]');
      if (!region) return;
      region.textContent = '';
      if (!state) { region.removeAttribute('data-pt-qb-loading-state'); return; }
      region.setAttribute('data-pt-qb-loading-state', state);
      region.textContent = state === 'loading' ? 'Loading recommendations…' : 'Recommendations could not load. ';
      if (state !== 'error') return;
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'pt-qb-retry';
      retry.textContent = 'Retry';
      retry.addEventListener('click', function () {
        if (refreshInFlight) return;
        requestedMembership = null;
        initialFeedback('loading');
        refreshRecommendations(true);
      });
      region.appendChild(retry);
    }

    function cartMembership() {
      var ids = {};
      var cart = window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart;
      if (cart && Array.isArray(cart.items)) {
        cart.items.forEach(function (item) { if (item.product_id) ids[String(item.product_id)] = true; });
        Object.keys(confirmedAdded).forEach(function (id) { if (ids[id]) delete confirmedAdded[id]; });
      }
      Object.keys(confirmedAdded).forEach(function (id) { ids[id] = true; });
      return ids;
    }
    function interactionBusy() {
      var active = document.activeElement;
      var focusedCard = active && active.closest && active.closest('#rebuy-widget-317188 .rebuy-product-block');
      return Date.now() < holdUntil || !!focusedCard ||
        (window.PTQuickBuy.isSheetActive && window.PTQuickBuy.isSheetActive()) ||
        Object.keys(operations).some(function (id) { return operations[id].phase === 'opening' || operations[id].phase === 'adding'; });
    }
    function scheduleRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshRecommendations, Math.max(0, holdUntil - Date.now()));
    }
    function refreshRecommendations(initialRetry) {
      if (!initialResponseSeen && initialRetry !== true) return;
      if (((!widget.View || !widget.View.vue) && initialResponseSeen) || !widget.data || !widget.data.config ||
          typeof widget.getWidgetProducts !== 'function' || interactionBusy()) return;
      var membership = Object.keys(cartMembership()).sort().join(',');
      if (membership === requestedMembership || (requestedMembership === null && !membership && initialResponseSeen)) return;
      if (refreshInFlight) { refreshAgain = true; return; }
      requestedMembership = membership;
      refreshInFlight = true;
      var finished = false;
      var timeout;
      function finish(succeeded) {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        refreshInFlight = false;
        // Only this request's callback confirms its success. An unrelated native
        // response cannot turn a failed refresh into a successful refresh.
        if (!succeeded) {
          requestedMembership = null; refreshAgain = false;
          if (!initialResponseSeen) initialFeedback('error');
        }
        else if (refreshAgain) { refreshAgain = false; scheduleRefresh(); }
      }
      // A failed read preserves existing cards. Retry is user/cart-event driven.
      timeout = setTimeout(function () { finish(false); }, 10000);
      try {
        widget.getWidgetProducts(function () {
          // The initial native request can fail before it ever creates a View.
          // Use the documented renderer only for that explicit Retry case.
          if (!widget.View || !widget.View.vue) {
            Promise.resolve(widget.render()).then(function () { finish(true); }, function () { finish(false); });
          } else finish(true);
        });
      } catch (error) { finish(false); }
    }

    widget.ptQuickBuyBeforeProductsChange = function (event) {
      var detail = event.detail || {};
      if (detail.widget !== widget || !Array.isArray(detail.products)) return;
      clearTimeout(initialWatchdog);
      initialFeedback(null);
      var current = (widget.data.products || []).slice(0, displayLimit);
      var inCart = cartMembership();
      if (!initialResponseSeen) {
        initialResponseSeen = true;
        requestedMembership = Object.keys(inCart).sort().join(',');
      }
      var defer = current.length > 0 && interactionBusy();
      if (defer) { requestedMembership = null; refreshAgain = true; }
      var retained = {};
      var selections = [];
      var fresh = {};
      detail.products.forEach(function (p) { fresh[String(p.id)] = p; });
      var slots = current.map(function (product) {
        var id = String(product.id);
        if (!defer && inCart[id]) return null;
        retained[id] = true;
        // Read choices NOW, after the request, so edits during its flight are retained.
        var choice = { product: product, quantity: product.quantity,
          variantId: product.selected_variant && product.selected_variant.id || product.selected_variant_id };
        selections.push(choice);
        var update = fresh[id];
        if (update && update !== product) {
          Object.keys(update).forEach(function (key) {
            if (!['quantity', 'selected_variant', 'selected_variant_id', 'option1', 'option2', 'option3', 'status'].includes(key)) product[key] = update[key];
          });
          var chosen = product.variants.filter(function (v) { return String(v.id) === String(choice.variantId); })[0];
          product.selected_variant = chosen || null;
        }
        return product;
      });
      var seen = {};
      var candidates = detail.products.filter(function (product) {
        var id = String(product.id);
        if (inCart[id] || retained[id] || seen[id] || !Array.isArray(product.variants) || !product.variants.length) return false;
        seen[id] = true;
        return true;
      });
      if (!defer) {
        for (var i = 0; i < displayLimit; i++) if (!slots[i]) slots[i] = candidates.shift() || null;
      }
      var result = slots.filter(Boolean);
      // Rebuy initProducts keeps product references on this non-variant-product path.
      // Restore only shopper choices after its synchronous initialization, before paint;
      // fresh price/availability fields stay fresh. No native method is overridden.
      Promise.resolve().then(function () {
        selections.forEach(function (choice) {
          var product = choice.product;
          product.quantity = choice.quantity;
          var variant = product.variants.filter(function (v) { return String(v.id) === String(choice.variantId); })[0];
          product.selected_variant = variant || null;
          product.selected_variant_id = variant ? variant.id : null;
          ['option1', 'option2', 'option3'].forEach(function (key) { product[key] = variant ? variant[key] : null; });
          var operation = operations[product.id];
          if (operation && (operation.phase === 'adding' || operation.phase === 'added')) product.status = operation.phase;
        });
      });
      detail.products.splice.apply(detail.products, [0, detail.products.length].concat(result));
    };
    document.addEventListener('rebuy:cart.change', scheduleRefresh);
    document.addEventListener('focusout', scheduleRefresh);
    document.addEventListener('pt:quickbuy:sheetclose', scheduleRefresh);
    widget.ptQuickBuyRefresh = scheduleRefresh;
    announce({ widgetId: '317188' });
    // A single failure deadline, never a polling or automatic retry loop.
    if (!initialResponseSeen) initialWatchdog = setTimeout(function () {
      if (!initialResponseSeen) initialFeedback('error');
    }, 10000);

    function openRecommendation(product, previewTrigger) {
      if (!product || busy[product.id]) return;
      var tags = Array.isArray(product.tags) ? product.tags.join(',') : product.tags;
      var mode = purchaseMode(product.id, tags, (product.variants || []).length);
      var url = widget.learnMoreURL(product);
      var plainUrl = url.replace(/([?&])variant=\d+&/, '$1').replace(/[?&]variant=\d+$/, '');
      if (mode === 'custom') { window.location.href = plainUrl; return; }
      var variant = product.selected_variant;
      var operation = { phase: 'opening' };
      operations[product.id] = operation;
      var root = widgetRoot(widget.id);
      var card = root && root.querySelector('.product-id-' + product.id);
      var feedbackTrigger = card && card.querySelector('.rebuy-product-actions .rebuy-button');
      var options = bindQuantity({
        handle: product.handle, productId: product.id, variantId: variant && variant.id,
        variantTitle: variant && variant.title, quantity: product.quantity,
        widgetId: String(widget.id), attribution: 'Rebuy Product', openCart: false,
        url: plainUrl, mode: mode, view: !!previewTrigger,
        trigger: previewTrigger || feedbackTrigger,
        kiwi: { title: product.title, tags: tags, vendor: product.vendor, collections: (product.collection_ids || []).join(',') }
      });
      function state(value) {
        var current = productFor(options) || product;
        flash(feedbackTrigger, value, current, function () {
          if (operations[product.id] === operation && operation.phase === 'added') {
            delete busy[product.id]; delete operations[product.id];
          }
        });
      }
      function sourceHold() {
        holdUntil = Math.max(holdUntil, Date.now() + feedbackTiming.source);
        state('added');
        scheduleRefresh();
      }
      options.onAdding = function () {
        operation.phase = 'adding'; operations[product.id] = operation; busy[product.id] = true;
        if (feedbackTrigger) feedbackTrigger.ptQbRequestPending = true;
        sourceError(options, null); state('adding');
      };
      options.onAdded = function (response, detail) {
        operation.phase = 'added';
        if (feedbackTrigger) feedbackTrigger.ptQbRequestPending = false;
        confirmedAdded[String(product.id)] = true;
        state('added');
        announce(options, detail.item, detail.variantTitle);
        if (!options.sheetActive) {
          if (document.activeElement === options.trigger) focusWidget(options);
          sourceHold();
        }
      };
      options.onAddError = function (error) {
        if (feedbackTrigger) feedbackTrigger.ptQbRequestPending = false;
        operation.phase = 'error'; state(null);
        delete busy[product.id]; delete operations[product.id];
        sourceError(options, error); scheduleRefresh();
      };
      options.onSheetClose = function () {
        if (operation.phase === 'opening' || operation.phase === 'error') {
          state(null);
          delete busy[product.id]; delete operations[product.id]; scheduleRefresh();
        } else if (operation.phase === 'added') sourceHold();
      };
      busy[product.id] = true;
      state('opening');
      // Even one-variant products pass the scoped sheet's no-choice check.
      var action = open(product.handle, options);
      return action.then(function (result) {
        if (operation.phase === 'opening') state(null);
        return result;
      }).catch(function () {
        if (operation.phase === 'opening') {
          state(null);
          delete busy[product.id]; delete operations[product.id]; window.location.href = plainUrl;
        }
      });
    }
    widget.addToCart = function (product) { return openRecommendation(product); };
    // Keep ordinary card discovery in the same guarded chooser as Add. Native
    // learnMore also navigates, so it must not run after a preview is opened.
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || !event.target.closest) return;
      var link = event.target.closest('#rebuy-widget-317188 a.rebuy-product-image, #rebuy-widget-317188 a.rebuy-product-title-link');
      if (!link) return;
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        event.stopPropagation(); // Retain the anchor's browser default, without native delayed navigation.
        return;
      }
      var card = link.closest('.rebuy-product-block');
      var product = card && (widget.data.products || []).find(function (item) { return card.classList.contains('product-id-' + item.id); });
      if (!product || purchaseMode(product.id, Array.isArray(product.tags) ? product.tags.join(',') : product.tags, (product.variants || []).length) === 'custom') return;
      event.preventDefault(); event.stopPropagation();
      if (busy[product.id]) return;
      track('click', null, { widget_id: String(widget.id), product_id: String(product.id), origin: 'rebuy', via: 'card', mode: 'preview' });
      openRecommendation(product, link);
    }, true);
    if (widget.View && widget.View.vue) { widget.View.vue.addToCart = widget.addToCart; scheduleRefresh(); }
  }

  // Register before the first native response, since rebuy.init follows that response.
  // Connecting here and forwarding the same event avoids missing its first commit.
  document.addEventListener('rebuy.beforeProductsChange', function (event) {
    var widget = event.detail && event.detail.widget;
    if (!widget || String(widget.id) !== '317188') return;
    if (!widget.ptQuickBuyConnected) connectNativeRecommendation(widget);
    widget.ptQuickBuyBeforeProductsChange(event);
  });
  document.addEventListener('rebuy.loaded', function () {
    if (window.Rebuy && Array.isArray(window.Rebuy.widgets)) window.Rebuy.widgets.forEach(connectNativeRecommendation);
  });
  document.addEventListener('rebuy.init', function (event) { connectNativeRecommendation(event.detail.widget); });
  document.addEventListener('rebuy.ready', function (event) { connectNativeRecommendation(event.detail.widget); });
  if (window.Rebuy && Array.isArray(window.Rebuy.widgets)) window.Rebuy.widgets.forEach(connectNativeRecommendation);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
  else startObserver();
})();
